/* eslint-disable no-console */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
// @mui
import {
  Stack, Typography, Box, Container, Grid, Card, CardHeader, IconButton,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
// components
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { forEach, flatten, uniq } from 'lodash';
import MultiSelector from '../components/multi-selector/multiSelector';
import VideoPlayer from '../components/video-player/videoPlayer';

export default function SensorLiveStream() {
  const sensorList = useSelector((state) => state.app.sensorList);
  const { adaptorType } = window;
  const [selectedSensorList, setSelectedSensorList] = useState([]);
  const [sensorListForNvStreamer, setSensorListForNvStreamer] = useState([]);
  const [selectedTagList, setSelectedTagList] = useState([]);
  const [inputTagValue, setInputTagValue] = useState('');
  const [uniqueTags, setUniqueTags] = useState([]);
  const [sensorInRow, setSensorInRow] = useState(2);
  const [inputValue, setInputValue] = useState('');
  const location = useLocation();

  const isStreamer = location.pathname === '/streamer/streams';

  useEffect(() => {
    window.liveStreamingSensors = selectedSensorList;
    return () => {
      window.LiveStreamingSensors = null;
    };
  }, [selectedSensorList]);

  useEffect(() => {
    // if sensor list refreshed, reset tag selections
    setSelectedTagList([]);
  }, [uniqueTags]);

  useEffect(() => {
    if (adaptorType === 'streamer') {
      const getUniqueTags = () => {
        try {
          let parsedTags = [];
          forEach(sensorList, (sensor) => {
            const { tags } = sensor;
            if (tags) {
              const locationArr = tags.split(',');
              parsedTags.push(locationArr);
            }
          });
          parsedTags = flatten(parsedTags);
          for (let i = 0; i < parsedTags.length; i += 1) {
            parsedTags[i] = parsedTags[i].trim();
          }
          parsedTags = uniq(parsedTags);
          setUniqueTags(parsedTags);
        } catch (error) {
          console.log('failed to parse tags');
        }
      };
      getUniqueTags();
    }
  }, [sensorList]);

  useEffect(() => {
    if (adaptorType === 'streamer') {
      const parsedSensorList = [];
      if (selectedTagList.length === 0) {
        setSensorListForNvStreamer(sensorList);
        return;
      }
      forEach(sensorList, (sensor) => {
        const { tags } = sensor;
        forEach(selectedTagList, (tag) => {
          if (tags.includes(tag)) {
            parsedSensorList.push(sensor);
            return false;
          }
          return true;
        });
        console.log('sensor name', sensor.name);
      });
      setSensorListForNvStreamer(parsedSensorList);
    }
  }, [selectedTagList, sensorList]);

  const handleInputValue = (val) => {
    setInputValue(val);
  };

  const handleInputTagValue = (val) => {
    setInputTagValue(val);
  };

  const handleSelectedSensorListChange = (val) => {
    setSelectedSensorList(val);
  };

  const handleSelectedTagChange = (val) => {
    setSelectedTagList(val);
  };

  const handleZoomOut = () => {
    setSensorInRow((prev) => (prev < 3 ? prev + 1 : prev));
  };

  const handleZoomIn = () => {
    setSensorInRow((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const closeSensor = (sensor) => {
    const temp = selectedSensorList.filter((item) => item.sensorId !== sensor.sensorId);
    setSelectedSensorList(temp);
  };

  // Filter out selected sensors from the sensorList
  const availableSensors = sensorList.filter(
    (sensor) => !selectedSensorList.some(selectedSensor => selectedSensor.sensorId === sensor.sensorId)
  );

  // Function to filter authorized sensors
  const filterAuthorized = (sensorList) => sensorList
    .filter((sensor) => sensor.isAuthorized === true);

  return (
    <div
      style={{
        display:
          location.pathname === '/vst/live-streams' || location.pathname === '/mms/live-streams' || isStreamer
            ? 'inline'
            : 'none',
      }}
    >
      <Helmet>
        <title> stream </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          {isStreamer ? 'Stream' : 'Live streams'}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title={isStreamer ? 'Stream' : 'Live streams'}
                subheader={isStreamer ? 'Stream multiple files' : 'Stream multiple live streams'}
              />
              <Box sx={{ p: 3 }}>
                {isStreamer && (
                  <Stack spacing={3} sx={{ mb: 1 }}>
                    <MultiSelector
                      id="nvstreamer-tag-selector"
                      placeholder="Type to search"
                      label="Select tags"
                      value={selectedTagList}
                      inputValue={inputTagValue}
                      onInputChange={handleInputTagValue}
                      onChange={handleSelectedTagChange}
                      getOptionLabel={(option) => `${option === '' ? 'EMPTY STRING' : option}`}
                      options={uniqueTags}
                    />
                  </Stack>
                )}
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <MultiSelector
                    id="live-stream-selector-multi"
                    placeholder="Type to search"
                    label={`Select ${adaptorType === 'streamer' ? 'files' : 'sensors'}`}
                    value={selectedSensorList}
                    inputValue={inputValue}
                    onInputChange={handleInputValue}
                    onChange={handleSelectedSensorListChange}
                    getOptionLabel={(option) => {
                      if (option.remoteDeviceName && option.remoteDeviceLocation) {
                        return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                      } if (option.remoteDeviceName) {
                        return `${option.name} at ${option.remoteDeviceName}`;
                      }
                      return option.name;

                    }}
                    options={isStreamer ? sensorListForNvStreamer : filterAuthorized(availableSensors)}
                  />
                </Stack>
                <Box
                  m={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  sx={{
                    display: {
                      xs: 'none', sm: 'none', md: 'none', lg: 'flex',
                    },
                  }}
                >
                  <IconButton onClick={handleZoomIn}>
                    <ZoomInIcon />
                  </IconButton>
                  <IconButton onClick={handleZoomOut}>
                    <ZoomOutIcon />
                  </IconButton>
                </Box>
              </Box>
            </Card>
          </Grid>
          {selectedSensorList.map((sensor) => (
            <Grid item xs={12} sm={12} md={12 / sensorInRow} key={sensor.sensorId}>
              <VideoPlayer
                sensor={sensor}
                sensorInRow={sensorInRow}
                isStreamer={isStreamer}
                // key={`${sensor.sensorId + sensor.host + sensor.name}_vid_live`}
                page="live"
                closeSensor={closeSensor}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
